import { ReactNode, useEffect, useState } from "react";

export interface ModalConfig {
  title: string;
  body?: ReactNode;
  danger?: string;
  /* Jerry 2026-07-27: deliberate friction — the confirm button stays disabled
     until the rider ticks the box. Used on the no-payment path where nothing
     else (no charge, no PIX) marks the moment the migration really starts. */
  checkboxLabel?: string;
  confirmLabel?: string;
  cancelLabel?: string;
  onConfirm?: () => void;
}

export function Modal({
  config,
  onClose,
}: {
  config: ModalConfig | null;
  onClose: () => void;
}) {
  const [checked, setChecked] = useState(false);
  useEffect(() => setChecked(false), [config]);

  if (!config) return null;
  const needsCheck = Boolean(config.checkboxLabel);
  return (
    <div className="lpc-modal" role="dialog" aria-modal="true">
      <div className="lpc-modal__box">
        <div className="lpc-modal__title">{config.title}</div>
        {config.body ? <div className="lpc-modal__body">{config.body}</div> : null}
        {config.danger ? <div className="lpc-modal__danger">{config.danger}</div> : null}
        {needsCheck ? (
          <label
            className={"lpc-modal__check" + (checked ? " is-on" : "")}
            data-testid="modal-check"
          >
            <input
              type="checkbox"
              checked={checked}
              onChange={(e) => setChecked(e.target.checked)}
            />
            <span>{config.checkboxLabel}</span>
          </label>
        ) : null}
        <button
          className="btn btn--primary"
          data-testid="modal-confirm"
          disabled={needsCheck && !checked}
          onClick={() => {
            onClose();
            config.onConfirm?.();
          }}
        >
          {config.confirmLabel ?? "Confirmar"}
        </button>
        <button className="btn btn--ghost" data-testid="modal-cancel" onClick={onClose}>
          {config.cancelLabel ?? "Voltar"}
        </button>
      </div>
    </div>
  );
}
